import { LAYOUT_CONTENT_HEIGHT } from '@/pages/Layout/constants'
import { Flex, Skeleton } from '@chakra-ui/react'

export default function InitiativeDashboardHomeSkeleton() {
  return (
    <Flex
      direction="column"
      bg="gray.50"
      minHeight={LAYOUT_CONTENT_HEIGHT}
      data-testid="dashboard-home-skeleton"
    >
      <Flex
        bg="white"
        px={4}
        py={3}
        gap={4}
        alignItems="center"
        borderBottomWidth="1px"
        borderColor="gray.100"
      >
        <Skeleton height="40px" width="64px" />
        <Flex direction="column" gap={2} flex={1}>
          <Skeleton height="12px" width="80px" />
          <Skeleton height="20px" width="240px" />
        </Flex>
      </Flex>
      <Flex direction="column" flex={1} p={4}>
        <Skeleton flex={1} minHeight="480px" borderRadius="md" />
      </Flex>
    </Flex>
  )
}
